/**
 * Makes API calls to Rebuy service and returns the results
 * @param {string} endpoint - The API endpoint to call
 * @param {Object} params - Parameters to send with the request
 * @param {string} [method='GET'] - HTTP method (GET, POST, PUT, DELETE)
 * @param {Object} [headers={}] - Additional headers for the request
 * @returns {Promise<Object>} - Promise resolving to the API response
 */
const callRebuyApi = async (
  endpoint,
  params = {},
  method = "GET",
  headers = {},
) => {
  const baseUrl = "https://rebuyengine.com/api/v1";
  const url = `${baseUrl}${endpoint}`;

  const defaultHeaders = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const requestOptions = {
    method,
    headers: { ...defaultHeaders, ...headers },
    // credentials: "include", // Include cookies if needed for auth
  };

  // Add body for POST, PUT requests
  if (["POST", "PUT"].includes(method) && Object.keys(params).length > 0) {
    requestOptions.body = JSON.stringify(params);
  }

  // Append query params for GET requests
  let requestUrl = url;
  if (method === "GET" && Object.keys(params).length > 0) {
    const queryString = new URLSearchParams(params).toString();
    requestUrl = `${url}?${queryString}`;
  }

  try {
    const response = await fetch(requestUrl, requestOptions);

    if (!response.ok) {
      throw new Error(
        `Rebuy API error: ${response.status} ${response.statusText}`,
      );
    }

    return await response.json();
  } catch (error) {
    console.error("Error calling Rebuy API:", error);
    throw error;
  }
};

// Export for use in other files
if (typeof module !== "undefined" && module.exports) {
  module.exports = { callRebuyApi };
} else {
  // Make available globally in browser environment
  window.callRebuyApi = callRebuyApi;
}
